{
  "app": {
    "name": "Azimut",
    "welcome": "Welcome to Azimut",
    "loading": "Loading...",
    "404": "Oops, this page does not seem to exist",
    "returnToHome": "Return to Home"
  },
  "errorOccurred": "An error occurred",
  "errorBoundary": {
    "title": "Data loading error",
    "description": "An error occurred while loading the data. Please try again later.",
    "returnHome": "Retry"
  },
  "navigation": {
    "home": "Home",
    "back": "Back",
    "showPageNavigator": "Show page navigator",
    "hidePageNavigator": "Hide page navigator",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "continuedOnPage": "Elements on another page"
  },
  "actions": {
    "save": "Save",
    "saveAndClose": "Save and close",
    "submitValidation": "Submit validation",
    "submittingValidation": "Submitting",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "confirm": "Confirm",
    "start": "Start",
    "continue": "Continue"
  },
  "common": {
    "refresh": "Refresh",
    "lastUpdatedAt": "Last updated: {{updatedAt}}",
    "unknown": "Unknown",
    "end": "End",
    "yes": "Yes",
    "no": "No",
    "selectPlaceholder": "Select..."
  },
  "policy": {
    "spill": "Spill",
    "accountName": "Account Name",
    "fileName": "File Name",
    "policyNumber": "Policy #",
    "insurer": "Insurer",
    "expiryDate": "Expiry Date",
    "technicalSupport": "Technical Support",
    "status": "Status",
    "assignation": "Assignation",
    "validationDate": "Validation Date",
    "filter": {
      "accountName": "Filter account name...",
      "fileName": "Filter file name...",
      "policyNumber": "Filter policy number...",
      "insurer": "Filter insurer...",
      "technicalSupport": "Filter technical support...",
      "status": "Filter status",
      "allStatus": "All"
    },
    "noPoliciesFound": "No policies found",
    "loadingPolicies": "Loading policies...",
    "inProgressTooltip": "This policy is already being validated by another user. Please refresh to update the status.",
    "noPdfAvailable": "No PDF available",
    "startPolicyErrorTitle": "Policy Already Open",
    "startPolicyErrorDescription": "This policy is currently being viewed by another user. Automatic synchronization may take up to 30s. You can also refresh now.",
    "assignmentConflictTitle": "Policy Modified by Another User",
    "assignmentConflictDescription": "This policy was taken over by another user while you were away. Your changes cannot be submitted. Please refresh the page to see the latest state.",
    "refreshNow": "Refresh Now",
    "carGroupTitle": "Vehicle(s)",
    "policyDetailsTitle": "Policy details",
    "policyDetails": {
      "contract": "Contract",
      "insuredNameAndAddress": "Insured name and mailing address",
      "documentType": "Document type",
      "duration": "Duration",
      "insurer": "Insurer",
      "isCrenaux": "Crénaux",
      "prime": "Premium",
      "insuredAddress": "Mailing address",
      "insuredName": "Insured name",
      "insuranceType": "Insurance type",
      "billingMethod": "Billing Method"
    },
    "assignments": {
      "title": "Premises, Property and Operations"
    },
    "financialData": {
      "description": "Description",
      "amount": "Amount"
    }
  },
  "policyList": "Policy Validation",
  "policyDetail": "Policy Details",
  "of": "of",
  "rowsPerPage": "Rows per page",
  "documents_one": "{{count}} document",
  "documents_other": "{{count}} documents",
  "PENDING_VALIDATION": "To validate",
  "IN_PROGRESS": "In progress",
  "NOT_COMPLETED": "Not completed",
  "COMPLETED": "Completed",
  "PENDING_COMPLETION": "Pending Completion",
  "FAILED": "Failed",
  "garantie": {
    "title": "Extracted Coverages",
    "garanties": "Coverages",
    "formulaire": "Form",
    "rp": "R.P.",
    "franchise": "Deductible",
    "montantGarantie": "Coverage Amount",
    "montantAssurance": "Insurance Amount",
    "prime": "Premium",
    "noGaranties": "No coverage extracted",
    "vehiculeNumber": "Vehicule N.",
    "year": "Year",
    "description": "Description (Make, Model)",
    "serialNumber": "Serial Number",
    "caracteristics": "Caracteristics"
  },
  "coverage": {
    "coherentExtraction": "Coherent extraction",
    "errorDetected": "Error detected",
    "addDescription": "Add a description",
    "required": "required",
    "descriptionPlaceholder": "Describe the detected error...",
    "addDescriptionTooltip": {
      "intro": "To help us correct the extraction, please specify:",
      "items": [
        "Where the error is located in the document (section, page, area)",
        "The exact text extracted by the extractor",
        "What the extractor should have extracted instead",
        "If any information is missing (which one, and where it is located)",
        "Whether this is a localization issue, a mismatched word/amount, or missing information"
      ],
      "outro": "The more detailed your comment is, the faster we can improve the extractor."
    },
    "missingSection": {
      "title": "Missing section"
    },
    "pageNumber": "Page number"
  },
  "statusBar": {
    "progress": "{{validated}}/{{total}} - {{errors}} Validated Section(s)",
    "submitDisabledTooltip": "Some data has not been validated. Please complete all tiles before submitting.",
    "submitSuccess": "Policy {{policyNumber}} was successfully submitted"
  },
  "externalLink": "External link",
  "billing": {
    "deversement": "Spill",
    "searchCode": "Search Code",
    "accountName": "Account Name",
    "policyNumber": "Policy #",
    "policyType": "Policy Type",
    "insurer": "Insurer",
    "activityCode": "Activity Code",
    "effectiveDate": "Effective Date",
    "expiryDate": "Expiry Date",
    "status": "Status",
    "cv1": "CV1",
    "gc1": "GC1",
    "technicalSupport": "Technical Support",
    "agencyOrDirectBilling": "Agency or Direct Billing",
    "service": "Service",
    "entity": "Entity",
    "inProgress": "In progress",
    "completedDate": "Completed Date",
    "associatedBy": "Associated By",
    "notes": "Comments",
    "agency": "Agency",
    "direct": "Direct",
    "filter": {
      "searchCode": "Filter search code...",
      "accountName": "Filter account name...",
      "policyNumber": "Filter policy number...",
      "policyType": "Filter policy type...",
      "insurer": "Filter insurer...",
      "activityCode": "Filter activity code...",
      "agencyOrDirectBilling": "Filter billing...",
      "all": "All",
      "associatedBy": "Filter associated by...",
      "status": "Filter status",
      "selected": "selected",
      "clear": "Clear",
      "technicalSupport": "Filter technical support...",
      "service": "Filter service...",
      "entity": "Filter entity...",
      "gc1": "Filter GC1..."
    },
    "noBillingsFound": "No billings found",
    "loadingBillings": "Loading billings...",
    "selectedEdocs": "selected eDocs",
    "assignToMyself": "Assign these eDocs to my account",
    "markedInProgress": "Marked billing as in progress",
    "failedToChangeStatus": "Failed to change billing status",
    "drawer": {
      "detailsTab": "Details",
      "documentsTab": "Documents",
      "noteSaved": "Note saved successfully",
      "noteSaveError": "Error saving note",
      "statusChanged": "Status changed to completed successfully",
      "statusChangeError": "Error changing status",
      "openByDifferentUser": "This policy is being modified by a different user.",
      "assignmentConflictError": "This billing has been taken over by another user. Please refresh the page.",
      "other": "Other (free text)",
      "saveAsCompleted": "Save as completed",
      "enterComment": "Type your comment...",
      "attachmentMetadataError": "Unable to load document name from EPIC",
      "retry": "Retry",
      "noAttachmentsFound": "No attachments found for this billing.",
      "policy": "Policy",
      "notes": "Notes",
      "document": {
        "name": "Policy document",
        "viewer": "Document viewer",
        "close": "Close document",
        "view": "View document",
        "hide": "Hide document",
        "toRename": "To rename"
      },
      "process": {
        "label": "Process",
        "placeholder": "Select a process",
        "inferredFrom": "Inferred from activity code: {{activityCode}}",
        "loadError": "Unable to load processes"
      },
      "rename": {
        "action": "Rename",
        "documentType": "Document type",
        "documentTypePlaceholder": "Select a document type",
        "rule": "Rule",
        "newName": "New name",
        "completeRequired": "Complete the required value to generate the name",
        "generatedName": "Generated name",
        "invalidDate": "The date must be in the YYYY-MM-DD format",
        "invalidAmount": "The amount must be a number with at most 2 decimals, e.g. 1234.50 or -865",
        "folder": "Folder",
        "subfolder": "Subfolder 1",
        "tokens": {
          "processus": "Process",
          "date": "Date",
          "dateFin": "End date",
          "dateSinistre": "Date of loss",
          "prime": "Premium",
          "montant": "Amount",
          "description": "Description",
          "participant": "Participant",
          "projet": "Project",
          "expert": "Adjuster"
        }
      }
    },
    "notesHistory": {
      "emptyTitle": "What are notes for?",
      "emptyDescription": "Record exchanges with the broker or the insured about this billing: each note is dated and signed, to make it easy for a colleague to pick up the file.",
      "authorOnly": "Only a note's author can edit or remove it.",
      "predefined": "Predefined note",
      "addNote": "Add a note",
      "noteUpdated": "Note updated successfully",
      "noteUpdateError": "Error updating note",
      "noteDeleted": "Note deleted successfully",
      "noteDeleteError": "Error deleting note",
      "deleteTitle": "Delete this note?",
      "deleteDescription": "This note will be removed from the billing history."
    }
  },
  "billingList": "Billing Validation",
  "renewalPrioritizer": "Renewal Prioritizer",
  "renewal": {
    "comparisonDrawer": "Policy Comparison",
    "renewalDrawer": "Renewal Details",
    "priorisation": "Prioritization",
    "policyIdentification": "Policy Identification",
    "renewal": "Renewal",
    "contractContext": "Contract Context",
    "compensationAndFees": "Compensation and Fees",
    "expiration": "Expiration",
    "alert": "Alert",
    "notes": "Notes",
    "status": "Status",
    "assignedTo": "Assigned to",
    "company": "Company",
    "policyNumber": "Policy #",
    "type": "Type",
    "insurer": "Insurer",
    "currentPremium": "Current Premium",
    "renewalPremium": "Renewal Premium",
    "premiumVariation": "Premium Variation",
    "amendments": "Amendments",
    "claims": "Claims",
    "commissionPercentage": "Commission %",
    "fees": "Honorary",
    "insurerFees": "Insurer Fees",
    "noRenewalsFound": "No Renewal Found",
    "loadingRenewals": "Loading renewals...",
    "daysAbbr": "days",
    "INITIATED": "Initiated",
    "IN_PROGRESS": "In progress",
    "STANDBY": "Standby",
    "STANDBY_INSURER": "Standby insurer",
    "DONE": "Done",
    "searchRenewal": "Search by policy number...",
    "removeFilters": "Remove filters",
    "all": "All",
    "self": "Me",
    "renewalPremiumLabel": "Renewal Premium",
    "assignedToLabel": "Assigned to",
    "alertsLabel": "Alerts",
    "statusLabel": "Status",
    "columnsLabel": "Columns",
    "expiresIn": "Expires in",
    "offerNotReceived": "The comparator is available once an offer is received.",
    "comparator": {
      "limit": "Limit",
      "rate": "Rate",
      "premium": "Premium",
      "comparative": "Comparative",
      "usageWarning": "This comparative table may not include all contract clauses. It is a comparison tool for given rates and premiums.",
      "grandTotal": "Annualized grand total",
      "noPreviousPeriod": "No previous period",
      "noRenewalPeriod": "No renewal period"
    },
    "filters": {
      "expiration": {
        "60less": "60 days or less",
        "120less": "120 days or less",
        "180less": "180 days or less",
        "200less": "200 days or less"
      }
    },
    "drawer": {
      "notesTab": "Notes",
      "analyseTab": "Analysis",
      "loadingData": "Loading data...",
      "statusChanged": "Status changed successfully",
      "statusChangeError": "Error changing status",
      "noteAdded": "Note added successfully",
      "addNoteError": "An error occured while adding this note",
      "alertsChanged": "Alerts changed successfully",
      "alertsChangeError": "An error occured while saving alerts",
      "selectAlertsPlaceholder": "Select alerts...",
      "assignationError": "An error occured while changing renewal assignation",
      "assignedToSelf": "Renewal successfully assigned to self",
      "self": "self",
      "newPolicyAlert": "The new insurance policy is available. You can now compare your documents.",
      "viewComparator": "View comparator",
      "downloadExcel": "Download Excel",
      "print": "Print"
    },
    "analysisTab": {
      "details": "Details",
      "status": "Status",
      "alerts": "Alerts",
      "assignedTo": "Assigned to",
      "contactName": "Contact Name",
      "phone": "Phone",
      "email": "Email",
      "primaryBroker": "Primary Broker",
      "accountManager": "Account Manager",
      "branchType": "Branch Type",
      "insurer": "Insurer",
      "profitCenter": "Profit Center",
      "premiumEvolution": "Premium Evolution",
      "amendments": "Amendments",
      "claims": "Claims",
      "recommendations": "Recommendations",
      "noTransactionsFound": "No transactions of this category were found."
    },
    "notesTab": {
      "title": "What are these notes for?",
      "description": "This space allows you to quickly track updates to the file, follow-ups with the client, or the status of the renewal.",
      "syncWarning": "Notes entered are not synchronized or linked to Epic.",
      "addNotePlaceholder": "Add a note"
    },
    "ENTR_AND_CGL": "ENTR & CGL",
    "CGL": "CGL",
    "ENTR": "ENTR",
    "AUTO": "AUTO",
    "CIME": "CIME",
    "UNKNOWN_USER": "Unknown user"
  },
  "notes": {
    "today": "Today",
    "yesterday": "Yesterday",
    "daysAgo_one": "{{count}} day ago",
    "daysAgo_other": "{{count}} days ago"
  },
  "documentViewer": {
    "loadError": "Unable to load the document"
  }
}
